import { render, staticRenderFns } from "./nav_pc.vue?vue&type=template&id=814fb538&scoped=true"
import script from "./nav_pc.vue?vue&type=script&lang=js"
export * from "./nav_pc.vue?vue&type=script&lang=js"
import style0 from "./nav_pc.vue?vue&type=style&index=0&id=814fb538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814fb538",
  null
  
)

export default component.exports